const projects = [
  {
    name: "StudyVault",
    emoji: "📚",
    tagline: "Full Stack Study Companion",
    description:
      "A comprehensive full-stack academic platform designed to empower students with instant access to high-quality educational resources—completely free.",
    tech: ["React", "Node.js", "Firebase", "Cloudinary"],
    accent: "text-[#ff6b35]",
    border: "hover:border-[#ff6b35]",
    topBar: "from-[#ff6b35]",
    tag: "bg-[rgba(255,107,53,0.08)] text-[#ff6b35] border-[rgba(255,107,53,0.2)]",
    featured: true,
    status: "Deployed on Vercel",
    github: "https://github.com/umar24nov",
    demo: "https://studyvaultapp.vercel.app/",
  },
  {
    name: "AcademicAI",
    emoji: "📊",
    tagline: "ML-Based Academic Forecasting",
    description:
      "ML app that analyses student attendance, grades and behaviour patterns to predict performance and flag at-risk students early — backed by a clean Fast API.",
    tech: ["Python", "Scikit-learn", "Pandas", "NumPy", "Fast API", "MySQL"],
    accent: "text-[#7c3aed]",
    border: "hover:border-[#7c3aed]",
    topBar: "from-[#7c3aed]",
    tag: "bg-[rgba(124,58,237,0.08)] text-[#7c3aed] border-[rgba(124,58,237,0.2)]",
    featured: true,
    status: "Deployed on Render",
    github: "https://github.com/umar24nov",
    demo: "https://academic-ai.onrender.com",
  },
  {
    name: "Portfolio Website",
    emoji: "🌐",
    tagline: "Personal Brand & Showcase",
    description:
      "This very site — animated React portfolio with scroll reveals, a code signature and GitHub stats. Built with React, Tailwind CSS & Framer Motion.",
    tech: ["React", "Tailwind CSS", "Framer Motion"],
    accent: "text-[#d63384]",
    border: "hover:border-[#d63384]",
    topBar: "from-[#d63384]",
    tag: "bg-[rgba(214,51,132,0.08)] text-[#d63384] border-[rgba(214,51,132,0.2)]",
    featured: false,
    status: "Live Now",
    github: "https://github.com/umar24nov",
    demo: "#",
  },
];

export default projects;
